import PropTypes from "prop-types";

export interface IconProps {
  fill?: string;
  width?: number;
  height?: number;
  className?: string;
}

export const iconPropTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
};

export const iconDefaultProps = {
  fill: "",
  width: 32,
  height: 32,
  className: "",
};
